const getFormData = (form: HTMLFormElement) => {
	const formDataObj: { [key: string | symbol | number]: any } = {};
	const formData = new FormData(form);

	formData.forEach((value, key) => {
		formDataObj[key] = value;
	});

	return formDataObj;
};

export default getFormData;
